import styled from 'styled-components'
import { HeightClass } from '~/utils/enum/classes'

export const Container = styled.div<{
  heightClass: HeightClass
  borderColor: string | false
}>`
  width: fit-content;
  border: 1px solid ${({ borderColor }) => borderColor || 'transparent'};
  margin: 0;
`
